module.exports = __webpack_public_path__ + "static/media/progger5.045d38b2.png";